import {ApiClient} from '@hconnect/apiclient'
import {KpiResponse} from '@hconnect/common/types'
import {useQuery} from '@tanstack/react-query'

import {KpiSearchQueryKey} from '../types'

export function useKpiSearch(plantCode: string, search?: string) {
  return useQuery<KpiResponse>({
    queryKey: [KpiSearchQueryKey, plantCode, search],
    queryFn: async () => {
      const path = `/kpieditor/plants/${plantCode}/kpis`
      const params = !search ? undefined : {search}
      const response = await ApiClient.axiosInstance.get<KpiResponse>(path, {params})
      return response.data
    }
  })
}
